// import {
//     getStore,
//
// } from '@/util/store';
const common = {
    state: {
        screen: -1,
        showCollapse: true,
        isCollapse: false,
        retrialInformation: '',//结案转再审反显的数据
        declareSubject: [
            [
                {
                    value: "0",
                    label: '关联人名单和关联关系说明',
                },
                {
                    value: "1",
                    label: '关联人信息变更',
                },
                {
                    value: "2",
                    label: '持有上市公司股份的情况已发生或拟发生较大变化',
                },
                {
                    value: "3",
                    label: '接受委托或者信托等方式持有上市公司5%以上股份',
                },
                {
                    value: "4",
                    label: '所持上市公司5%以上股份被质押、冻结、司法拍卖、托管、设定信托或者被依法限制表决权等，或者出现被强制过户风险',
                },
                {
                    value: "5",
                    label: '经营财务状况恶化、担保人或者担保物发生变化导致或者可能导致其无法履行对上市公司的承诺',
                },
                {
                    value: "6",
                    label: '出现债务逾期或者其他资信恶化情形',
                },
                {
                    value: "7",
                    label: '进入或者拟进入破产、清算等程序',
                },
                {
                    value: "8",
                    label: '受到刑事处罚',
                },
                {
                    value: "9",
                    label: '涉嫌违法违规被证监会立案调查或者受到证监会行政处罚',
                },
                {
                    value: "10",
                    label: '受到证监会外的其他机关的行政处罚',
                },
                {
                    value: "11",
                    label: '涉嫌严重违纪违法或者职务犯罪被纪检监察等机关采取留置措施且影响其履行职责',
                },
                {
                    value: "12",
                    label: '对公司进行重大资产、 债务重组或者业务重组',
                },

            ],
            [
                {
                    value: "0",
                    label: '关联人名单和关联关系说明',
                },
                {
                    value: "1",
                    label: '持有上市公司股份的情况已发生或拟发生较大变化',
                },
                {
                    value: "2",
                    label: '控制公司的情况已发生或拟发生较大变化',
                },
                {
                    value: "3",
                    label: '接受委托或者信托等方式持有上市公司5%以上股份',
                },
                {
                    value: "4",
                    label: '被法院裁定禁止转让其所持上市公司股份',
                },
                {
                    value: "5",
                    label: '所持上市公司5%以上股份被质押、冻结、司法拍卖、托管、设定信托或者被依法限制表决权等，或者出现被强制过户风险',
                },
                {
                    value: "6",
                    label: '经营财务状况恶化、担保人或者担保物发生变化导致或者可能导致其无法履行对上市公司的承诺',
                },
                {
                    value: "7",
                    label: '出现债务逾期或者其他资信恶化情形',
                },
                {
                    value: "8",
                    label: '进入或者拟进入破产、清算等程序',
                },
                {
                    value: "9",
                    label: '涉嫌犯罪被采取强制措施',
                },
                {
                    value: "10",
                    label: '受到刑事处罚',
                },
                {
                    value: "11",
                    label: '涉嫌违法违规被证监会立案调查或者受到证监会行政处罚',
                },
                {
                    value: "12",
                    label: '受到证监会外的其他机关的行政处罚',
                },
                {
                    value: "13",
                    label: '涉嫌严重违纪违法或者职务犯罪被纪检监察等机关采取留置措施且影响其履行职责',
                },
                {
                    value: "14",
                    label: '控制的其他企业从事与公司相同或相似业务的情况发生较大变化',
                },
                {
                    value: "15",
                    label: '对公司进行重大资产、 债务重组或者业务重组',
                },
                {
                    value: "16",
                    label: '出现与控股股东有关的报道或者传闻，可能对上市公司股票及其衍生品种交易价格产生较大影响',
                },


            ],
            [
                {
                    value: "0",
                    label: '关联人名单和关联关系说明',
                },
                {
                    value: "1",
                    label: '关联人信息变更',
                },
                {
                    value: "2",
                    label: '持有上市公司股份或者控制公司的情况已发生或拟发生较大变化',
                },
                {
                    value: "3",
                    label: '接受委托或者信托等方式持有上市公司5%以上股份',
                },
                {
                    value: "4",
                    label: '被法院裁定禁止转让其所持上市公司股份',
                },
                {
                    value: "5",
                    label: '所持上市公司5%以上股份被质押、冻结、司法拍卖、托管、设定信托或者被依法限制表决权等，或者出现被强制过户风险',
                },
                {
                    value: "6",
                    label: '经营财务状况恶化、担保人或者担保物发生变化导致或者可能导致其无法履行对上市公司的承诺',
                },
                {
                    value: "7",
                    label: '出现债务逾期或者其他资信恶化情形',
                },
                {
                    value: "8",
                    label: '进入或者拟进入破产、清算等程序',
                },
                {
                    value: "9",
                    label: '涉嫌犯罪被采取强制措施',
                },
                {
                    value: "10",
                    label: '受到刑事处罚',
                },
                {
                    value: "11",
                    label: '涉嫌违法违规被证监会立案调查或者受到证监会行政处罚',
                },
                {
                    value: "12",
                    label: '受到证监会外的其他机关的行政处罚',
                },
                {
                    value: "13",
                    label: '涉嫌严重违纪违法或者职务犯罪被纪检监察等机关采取留置措施且影响其履行职责',
                },
                {
                    value: "14",
                    label: '控制的其他企业从事与公司相同或相似业务的情况发生较大变化',
                },
                {
                    value: "15",
                    label: '对公司进行重大资产、 债务重组或者业务重组',
                },
                {
                    value: "16",
                    label: '出现与控股股东有关的报道或者传闻，可能对上市公司股票及其衍生品种交易价格产生较大影响',
                }


            ],
            [
                {
                    value: "0",
                    label: '关联人名单和关联关系说明',
                },
                {
                    value: "1",
                    label: '关联人信息变更',
                },
                {
                    value: "2",
                    label: '持有上市公司股份情况的变化情况',
                },
                {
                    value: "3",
                    label: '涉嫌违纪违法或者职务犯罪被纪检监察等机关采取留置措施且影响其履行职责',
                },
                {
                    value: "4",
                    label: '因身体、工作安排等原因无法正常履行职责达到或者预计达到三个月以上',
                },
                {
                    value: "5",
                    label: '受到刑事处罚',
                },
                {
                    value: "6",
                    label: '涉嫌违法违规被证监会立案调查或者受到证监会行政处罚',
                },
                {
                    value: "7",
                    label: '受到证监会外的其他机关的行政处罚',
                },

            ],
            [
                {
                    value: "0",
                    label: '增持行为事前信息披露',
                },

                {
                    value: "1",
                    label: '增持行为事后信息披露',
                },
                {
                    value: "2",
                    label: '减持行为事前信息披露',
                },
                {
                    value: "3",
                    label: '减持行为事后信息披露',
                },
                {
                    value: "4",
                    label: '增持行为事中信息披露',
                },
                {
                    value: "5",
                    label: '减持行为事中信息披露',
                },

            ],
            [
                {
                    value: "0",
                    label: '/',
                },


            ]


        ],        //申报主体类别
        typeList: [
            {
                id: 0,
                value: '立案',
            },
            {
                id: 1,
                value: '仲裁',
            },
            {
                id: 2,
                value: '劳动仲裁',
            },
            {
                id: 3,
                value: '一审',
            },
            {
                id: 4,
                value: '二审',
            },
            {
                id: 5,
                value: '再审',
            },
            {
                id: 6,
                value: '结案',
            },
            {
                id: 7,
                value: '执行',
            },
        ],
        complianceSta: [{
            id: 0,
            value: '暂存',
        },
            {
                id: 1,
                value: '未答复',
            }
            ,
            {
                id: 2,
                value: '已答复',
            },
            {
                id: 3,
                value: '已退回',
            }
            ,
            {
                id: 4,
                value: '超时答复',
            },
            {
                id: 5,
                value: '已分配',
            }
        ],
        stateCase: [{
            id: 0,
            value: '暂存',
        },
            {
                id: 1,
                value: '审批中',
            },
            {
                id: 2,
                value: '退回',
            },
            {
                id: 3,
                value: '审批通过',
            }
            ,
            {
                id: 4,
                value: '转下阶完成',
            }
            ,
            {
                id: 5,
                value: '拿回',
            }
            ,
            {
                id: 6,
                value: '拿回',
            },
            {
                id: 7,
                value: '退回',
            }
        ],

        //合规状态
        stateCase1: [{
            id: 0,
            value: '暂存',
        },
            {
                id: 1,
                value: '审批中',
            },
            {
                id: 99,  //99 查询是所有类型退回 申报列表查询
                value: '退回',
            },
            {
                id: 98,  //98 查询是所有类型拿回 申报列表查询
                value: '拿回',
            },
            {
                id: 3,
                value: '审批通过',
            }

        ],
        //保全
        stateCase2: [{
            id: 0,
            value: '暂存',
        },
            {
                id: 1,
                value: '审批中',
            },
            {
                id: 2,
                value: '退回',
            },
            {
                id: 3,
                value: '审批通过',
            }
            ,
            {
                id: 4,
                value: '解除',
            }
            ,
            {
                id: 5,
                value: '拿回',
            }
            ,
            {
                id: 6,
                value: '拿回',
            },
            {
                id: 7,
                value: '退回',
            }
        ],
        dictionary: {
            arbitrationTribunalL: [],//常用仲裁庭
            courtLst: [],//常用法院
            executionOfApplication: [],
            describe: [],
            identityAgent: [],
            isHeadOffice: [],
            goodAtField: [],// 擅长领域
            educationBackground: [],//最高学历
            riskItems: [],//风险名称
            department: [],//部门
            recoveryTime: [],
            complianceRiskAll: [],
            complianceRisk: [],// 合规风险类别
            arbitrationAward: [],//仲裁裁决方式
            ExecutionStatus: [],//执行状态
            agent: [],//代理人
            Participants: [],//庭审参与人
            RulingWay: [],//裁决方式
            secondIdentity: [],//二审身份
            arbitratingIdentity: [],//仲裁我方身份
            trialAay: [], //审理方式
            reviewStatus: [],
            recordTypeList: [],
            //申报主体类别
            declareSubject: [],
            //担保形式4
            guaranteeType: [],
            //委托授权5
            permissions: [],
            //案由
            causeActionList: [],
            //案由
            causeAction: [],
            //案件进度6
            caseProgress: [],
            //案件类型7
            LawCaseTypeOption: [],
            //争议解决方式8
            controversy: [],
            //律所
            lawFirms: [{
                label: '天津栢柯事务所',
                value: '0',
            },],
            //结案方式9
            settlementWay: [],
            //申请事项10
            ApplyForItems: [],
            country: [{
                label: '天津栢柯事务所',
                value: '0',
            },],
            //我方涉案单位
            unit: [{
                label: '天津栢柯事务所',
                value: '0',
            },],
            //法院
            courtList: [],
            //是or否11
            is: [],
            //业务板块12
            businessSector: [],
            //责任范围13
            LimitationLiability: [],
            //我方身份  14
            ourPositionOption: [],
            arbitrationTribunal: [],//仲裁庭
            identityAll:[],//我方身份-综合查询
        }
    },

    mutations: {
        SET_SCREEN: (state, screen) => {
            state.screen = screen;
        },
        SET_COLLAPSE: (state) => {
            state.isCollapse = !state.isCollapse;
        },
        SET_DICTIONARY: (state, data) => {
            state.dictionary = data;
        },
    },
};
export default common;
